import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const services = [
  {
    title: 'Web Development',
    description: 'Custom, scalable, and responsive websites using modern frameworks like React, Next.js, and Tailwind CSS.',
    icon: '🌐',
  },
  {
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive designs focused on enhancing user experience and increasing engagement.',
    icon: '🎨',
  },
  {
    title: 'Mobile App Development',
    description: 'Cross-platform mobile apps built with React Native and Flutter for iOS and Android.',
    icon: '📱',
  },
  {
    title: 'Digital Strategy',
    description: 'Smart strategies tailored to your business goals — SEO, branding, and user journey planning.',
    icon: '📈',
  },
  {
    title: 'Cloud Solutions',
    description: 'Deploy, scale, and secure your apps with modern cloud platforms like AWS, Azure, and Firebase.',
    icon: '☁️',
  },
  {
    title: 'Maintenance & Support',
    description: 'Ongoing support to keep your digital products updated, optimized, and running smoothly.',
    icon: '🛠️',
  },
];

export default function ServicesPage2() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <main className="bg-white text-gray-800">
      <Helmet>
       
        <meta name="description" content="Explore Codexa's web development, design, cloud, and digital strategy services." />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-indigo-600 text-white text-center py-20">
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4">What We Offer</h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto">
            At Codexa, we deliver high-performance, beautifully designed digital solutions tailored to your success.
          </p>
        </motion.div>
      </section>

      {/* Services Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold text-center text-indigo-600 mb-12">
            Our Services
          </h2>

          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service, idx) => (
              <motion.div
                key={idx}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl border border-gray-100"
                whileHover={{ scale: 1.03 }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="text-5xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold text-indigo-700 mb-2">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* CTA Section */}
      <section className="bg-indigo-50 py-16">
        <motion.div
          className="text-center max-w-2xl mx-auto px-4"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold text-indigo-700 mb-4">
            Ready to build something amazing?
          </h2>
          <p className="text-gray-600 mb-6">
            Let’s partner up and turn your ideas into digital success. Whether it's a startup, business, or personal brand — Codexa has your back.
          </p>
          <a
            href="/contact"
            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white text-lg px-8 py-3 rounded-lg shadow-lg transition"
          >
            Get in Touch
          </a>
        </motion.div>
      </section>
    </main>
  );
}
